import React from "react";

export default function Eyebrow({ index, children, className = "", dot = true }) {
  return (
    <div
      className={[
        "inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-muted",
        className,
      ].join(" ")}
    >
      {dot ? (
        <span className="h-1.5 w-1.5 rounded-full bg-hint-strong shadow-[0_0_14px_rgba(45,226,232,0.7)]" />
      ) : null}
      {index ? <span className="text-ink/40">{index}</span> : null}
      <span>{children}</span>
    </div>
  );
}
